var _path, _rect, _path2, _path3, _path4, _rect2, _path5, _path6, _path7, _rect3, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTotalSeats(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.30859 9C5.30859 8.44771 5.75631 8 6.30859 8H11.7758C12.3281 8 12.7758 8.44772 12.7758 9V13.8952H5.30859V9Z",
    fill: "#FA5B49"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 14.5498,
    width: 10.0873,
    height: 2.35808,
    rx: 1.17904,
    fill: "#FA5B49"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.65625 17.3013H6.88332V19.5371C6.88332 20.1111 6.41801 20.5764 5.84402 20.5764V20.5764C5.18803 20.5764 4.65625 20.0446 4.65625 19.3886V17.3013Z",
    fill: "#FA5B49"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2051 17.3013H13.4321V19.5371C13.4321 20.1111 12.9668 20.5764 12.3928 20.5764V20.5764C11.7369 20.5764 11.2051 20.0446 11.2051 19.3886V17.3013Z",
    fill: "#FA5B49"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5547 9C28.5547 8.44771 29.0024 8 29.5547 8H35.0219C35.5742 8 36.0219 8.44772 36.0219 9V13.8952H28.5547V9Z",
    fill: "#FA5B49"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 27.2461,
    y: 14.5498,
    width: 10.0873,
    height: 2.35808,
    rx: 1.17904,
    fill: "#FA5B49"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8984 17.3013H30.1255V19.5371C30.1255 20.1111 29.6602 20.5764 29.0862 20.5764V20.5764C28.4302 20.5764 27.8984 20.0446 27.8984 19.3886V17.3013Z",
    fill: "#FA5B49"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4512 17.3013H36.6782V19.5371C36.6782 20.1111 36.2129 20.5764 35.6389 20.5764V20.5764C34.983 20.5764 34.4512 20.0446 34.4512 19.3886V17.3013Z",
    fill: "#FA5B49"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2344 15.8369C16.2344 15.2846 16.6821 14.8369 17.2344 14.8369H24.7645C25.3168 14.8369 25.7645 15.2846 25.7645 15.8369V22.9592H16.2344V15.8369Z",
    fill: "#FA5B49"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 14.666,
    y: 23.877,
    width: 12.6667,
    height: 3.1441,
    rx: 1.57205,
    fill: "#FA5B49"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3887 27.6753H18.2839V30.7783C18.2839 31.5245 17.679 32.1294 16.9328 32.1294V32.1294C16.08 32.1294 15.3887 31.4381 15.3887 30.5853V27.6753Z",
    fill: "#FA5B49"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7129 27.6753H26.6081V30.7783C26.6081 31.5245 26.0032 32.1294 25.257 32.1294V32.1294C24.4042 32.1294 23.7129 31.4381 23.7129 30.5853V27.6753Z",
    fill: "#FA5B49"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalSeats);
export default __webpack_public_path__ + "static/media/TotalSeats.686299c7376699aefb17d7cc626295cc.svg";
export { ForwardRef as ReactComponent };